import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {useDispatch, useSelector} from 'react-redux';
import {DialogAction, DialogBody} from 'routes/App/dashboard/styles';
import {Body1, Caption1} from 'components/typography';
import {FlexContainer} from 'components/layout';
import ButtonPrimary from 'components/buttons/ButtonPrimary/styles';
import ButtonInfo from 'components/buttons/ButtonInfo/styles';
import {
  PATCH_LOCATION_ACTION,
  TURN_OFF_COMPLETED_NOTIFICATION
} from 'store/ordersV2/orderList/action';
import DialogContainer from 'components/DialogContainer/styles';
import DialogClose from 'components/DialogClose/styles';
import DialogTitle from 'components/DialogTitle/styles';
import CheckboxContainer from 'components/Checkbox/styles';

export default function OrdersSettings({onClose}) {
  const dispatch = useDispatch();

  const {locationName} = useSelector((state) => state.user);

  const {
    locationData: {RushHourPerMinute},
    testOrderLoading
  } = useSelector((state) => state.ordersHistoryV2Reducer);
  const {ShowCompletedOrderNotification} = useSelector(
    (state) => state.user.userData
  );

  const [checkbox, setCheckbox] = useState(!!RushHourPerMinute);
  const [completedNotification, setCompletedNotification] = useState(
    ShowCompletedOrderNotification
  );
  const [rushHourPerMinute, setRushHourPerMinute] = useState(
    RushHourPerMinute || null
  );

  const handleSubmit = () => {
    if (rushHourPerMinute) {
      dispatch(
        PATCH_LOCATION_ACTION({
          RushHourPerMinute: checkbox ? rushHourPerMinute : null
        })
      );
      onClose();
    }
  };

  const handleCompletedNotification = (event) => {
    const {checked} = event.target;
    setCompletedNotification(checked);
    dispatch(TURN_OFF_COMPLETED_NOTIFICATION(checked));
  };

  return (
    <Dialog open onClose={onClose} scroll='body'>
      <DialogContainer className='DialogMd'>
        <DialogClose onClick={onClose} />
        <DialogTitle className='marginBottomXl'>Orders Settings</DialogTitle>
        <DialogBody>
          <div
            className='marginBottomMd'
            style={{display: 'flex', alignItems: 'center'}}
          >
            <Body1 className='inlineBlock marginRightSm'>Now Editing:</Body1>
            <Caption1>{locationName}</Caption1>
          </div>

          <div className='marginBottomMd'>
            <FlexContainer className='align-center'>
              <CheckboxContainer>
                <FormControlLabel
                  className='Say2EatCheckbox'
                  control={
                    <Checkbox
                      labelStyle={{color: '#172751'}}
                      iconStyle={{fill: '#FF2D38'}}
                      inputStyle={{color: '#FF2D38'}}
                      style={{color: '#FF2D38'}}
                      checked={completedNotification}
                      onChange={(event) => handleCompletedNotification(event)}
                    />
                  }
                  label='Show Completed Status Notification'
                />
              </CheckboxContainer>
              <ButtonInfo className='Outline ButtonInfoDrop'>
                <div className='DropInfo DropInfoCenter DropInfoRightMob'>
                  Control whether you want to see a Completed notification
                  whenever order status changes to Completed
                </div>
              </ButtonInfo>
            </FlexContainer>
          </div>

          <DialogAction>
            <ButtonPrimary onClick={onClose}>
              <span>Close</span>
            </ButtonPrimary>
          </DialogAction>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
}

OrdersSettings.propTypes = {
  onClose: PropTypes.func
};

OrdersSettings.defaultProps = {
  onClose: () => {}
};
